// @flow
import React from 'react';
import { Icon, Tooltip } from 'client-web-app/ui';
import { colors } from 'bench-style-constants';
import styled from 'styled-components';

const DataEntryStatusLayout = styled.span`
  align-items: center;
  background-color: ${({ showDarkButton }) => (showDarkButton ? colors.charcoal : colors.shell)};
  border-radius: 20px;
  display: flex;
  padding: 8px 16px 8px 11px;
`;

const DataEntryStatusText = styled.div`
  color: ${colors.bonsai};
  overflow: hidden;
  padding-left: 4px;
  text-overflow: ellipsis;
`;

const DataEntryStatusTooltipText = styled.div`
  color: ${colors.white};
  letter-spacing: normal;
  line-height: 16px;
  width: 321px;
`;

const DataEntryStatusTooltipWrapper = styled.span`
  padding-top: 6px;
`;

type DataEntryStatusProps = {
  ledgerName: string,
  ledgerNameTestId: string,
  showDarkButton: boolean,
};

const DataEntryStatus = ({
  ledgerName,
  ledgerNameTestId,
  showDarkButton,
}: DataEntryStatusProps) => (
  <DataEntryStatusTooltipWrapper>
    <Tooltip
      shouldUpdateOnOpen
      inlineFlex={false}
      tooltipContent={
        <DataEntryStatusTooltipText>
          This transaction has been automatically categorized. Your bookkeeper will be reviewing
          each transaction to ensure everything is categorized correctly.
        </DataEntryStatusTooltipText>
      }
      placement="top"
      styleType="dark"
    >
      <DataEntryStatusLayout showDarkButton={showDarkButton}>
        <Icon color={colors.bonsai} size="24px" icon="clock" />
        <DataEntryStatusText data-test-id={ledgerNameTestId}>{ledgerName}</DataEntryStatusText>
      </DataEntryStatusLayout>
    </Tooltip>
  </DataEntryStatusTooltipWrapper>
);

export default DataEntryStatus;
